import React, { Component, ReactElement, ReactNode, useState } from "react";
import SocialBlock from "src/interactions/components/SocialBlock";
import { SocialFeedType } from "src/social-feed";
import { SocialPost } from "../SocialPost";
import "./SocialPostContainer.scss";
import { SpintrTypes } from "src/typings";
import classNames from "classnames";
import { InteractiveTextFormatOptions } from "src/utils";
import { Label, setFocusCommentFieldForUberId, UnstyledButton } from "src/ui";
import { localize } from "src/l10n";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { useDispatch, useSelector } from "react-redux";
import SystemStatusStartItem from "src/system-status/SystemStatusStartItem";
import { CaptionBody, SmallHeading } from "src/components";
import SystemStatusStatus from "src/system-status/SystemStatusStatus";
import { formatDates } from "src/system-status/utils";
import SocialPostText from "../SocialPostText/SocialPostText";
import SystemStatusFeedItem from "src/system-status/SystemStatusFeedItem";

interface ISocialPostContainerProps {
    identity?: any;
    isShare?: boolean;
    post: Spintr.ISocialPostBase;
    feedType?: SocialFeedType;
    onDoneEditing?: any;
    interactiveTextOptions?:    InteractiveTextFormatOptions | undefined;
    index?: number;
}

interface IState {
    expanded: boolean;
}

function SocialPostContainer(props: ISocialPostContainerProps): ReactElement {
    const dispatch = useDispatch();
    const [state, setState] = useState<IState>({
        expanded: props.feedType !== SocialFeedType.SystemStatus
    });

    const systemStatusPost = props.post.content.find((c) => c.Type === SpintrTypes.UberType.SystemStatus) as Spintr.ISocialSystemStatus;

    if (!!systemStatusPost && !state.expanded) {
        return (
            <SystemStatusFeedItem
                post={systemStatusPost}
                parentPost={props.post}
                interactiveTextOptions={props.interactiveTextOptions}
                isMinified={true}
                onExpand={() => {
                    setState((prevState) => ({ ...prevState, expanded: !prevState.expanded }));
                    dispatch(setFocusCommentFieldForUberId(props.post.Id));              
                }}
            />
        )
    }

    let commentPlaceholder: string | undefined = !!systemStatusPost && (localize("COMPOSER_QUESTION"));

    return (
        <div className={classNames("SocialPostContainer visage-box-shadow start-page-flexible-padding")}>
            <div className="post-wrapper">
                <SocialPost
                    post={props.post}
                    onDoneEditing={props.onDoneEditing}
                    feedType={props.feedType}
                    interactiveTextOptions={props.interactiveTextOptions}
                />
            </div>
            {!props.isShare &&
                !props.post.hidden &&
                (props.post.StatusType !== SpintrTypes.StatusType.SystemStatus ||
                    props.feedType === SocialFeedType.SystemStatus ||
                    props.feedType === undefined) && (
                        <SocialBlock
                            onCommentIconClick={() => { }}
                            commentPlaceholder={commentPlaceholder}
                            uberId={props.post.Id}
                            comments={props.post.comments}
                            likers={props.post.likers}
                            identity={props.identity}
                            sendToMixpanel={props.feedType === SocialFeedType.Combined}
                            enableReactions={true}
                            displayBigButtons={true}
                            isFeedPost={true}
                            targetCreatorId={props.post.UserId}
                            targetIsQuestion={props.post.StatusType === SpintrTypes.StatusType.Question}
                            mentionedUsersHasAccess={props.post.mentionedUsersHasAccess}
                            feedType={props.feedType}
                        />
            )}
        </div>
    );
}


export default SocialPostContainer;